import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { LessonListVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { retrievePaymentLessonList } from "./retrieve-payment-lesson-list";

const initialState: RetrievalState<LessonListVM> = { fetching: "idle", data: [] };

export const retrievePaymentLessonListReducer = createReducer<RetrievalState<LessonListVM>>(initialState, builder => {
  builder.addCase(retrievePaymentLessonList.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrievePaymentLessonList.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrievePaymentLessonList.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
